import {Component, Input} from '@angular/core';

import {select} from '@angular-redux/store';
import {ActionsService} from '../../../../Redux/Actions/actions.service';
import {ApplicationSpecActions} from '../../../../Redux/Actions/application-spec-actions';
import {IInput, IOutput} from '../../../../models/ISpec';
import {IEntityAlert, IKeyValuePair} from '../../../../models/common';
import {ADD_OUTPUT, REMOVE_OUTPUT} from '../../../../models/view';
import {ResetSpecsService} from "../../../../components/reset-specs.service";
import {Observable} from "rxjs";
import {map, mergeMap} from "rxjs/operators";
import {Utils} from "../../../../common/utils";

@Component({
  selector: 'dcdc-specification-view',
  templateUrl: './specification-view.component.html',
  styleUrls: ['./specification-view.component.css']
})
export class DcDcSpecificationViewComponent {
  /**
   * Se deve essere presente graficamente la shadow
   */
  @Input() shadow: boolean = true;
  @Input() minOutput: number = 0;
  /**
   * Se deve essere presente il tasto addButton
   */
  @Input() addButton: boolean = true;

  @select(['appSpec', 'spec', 'value', 'input']) inputVal$: Observable<IInput<number>>;
  @select(['appSpec', 'spec', 'note', 'input']) inputNote$: Observable<IInput<IEntityAlert>>;

  @select(['appSpec', 'spec', 'value', 'output']) outputVal$: Observable<IOutput<number>>;
  @select(['appSpec', 'spec', 'note', 'output']) outputNote$: Observable<IOutput<IEntityAlert>>;

  @select(['appSpec', 'outputBounds']) outputBounds$;
  @select(['appSpec', 'noteGlobal']) noteGlobal$;

  resetAllEnabled$: Observable<boolean>;
  initialSpec: {
    inputEdited: boolean,
    outputEdited: boolean
  };
  constructor(private act: ActionsService, private resetAll: ResetSpecsService) {
    /**
     * Inizializzato con quello presente su AppComponent
     */
    const inputChanged = this.inputVal$.pipe(
      map(x => Utils.isValueReal(x.min) || Utils.isValueReal(x.max)),
    );
    const outputChanged = this.outputVal$.pipe(
      map(x => x.globalOutput.voltage !== null || x.globalOutput.current !== null ),
    );
    this.resetAllEnabled$ = inputChanged.pipe(
      mergeMap(x => outputChanged.pipe(map(y => x || y))),
    );
    this.initialSpec = {
      inputEdited: false,
      outputEdited: false
    };
  }

  checkSpecEdited(inputEdited: boolean, outputEdited: boolean) {
    if (inputEdited !== null) {
      this.initialSpec.inputEdited = inputEdited;
    }
    if (outputEdited !== null) {
      this.initialSpec.outputEdited = outputEdited;
    }

    this.act.sendAction(ApplicationSpecActions.editSpec(
      this.initialSpec.inputEdited || this.initialSpec.outputEdited)
    );
  }

  setVinRange(vinRange: IInput<number>) {
    // this.testInput = vinRange;
    this.checkSpecEdited((vinRange.min !== null && !isNaN(vinRange.min)) || (vinRange.max !== null && !isNaN(vinRange.max)), null);
    this.act.sendAction(ApplicationSpecActions.setInputLimits(vinRange));
  }

  onChangeOutput(event: IOutput<number>) {
    // this.testOutput = event;
    this.checkSpecEdited(null, event.outputs.length > 1 || (
        (event.outputs[0].voltage !== null && !isNaN(event.outputs[0].voltage)) || (event.outputs[0].current !== null && !isNaN(event.outputs[0].current))
      ));
    this.act.sendAction(ApplicationSpecActions.setOutputValue(event));
  }

  onResizeOutput(event: IKeyValuePair) {
    // console.log("Resize output", event)
    if (event.key === ADD_OUTPUT.key) {
      this.act.sendAction(ApplicationSpecActions.addOutput());
    } else if (event.key === REMOVE_OUTPUT.key) {
      this.act.sendAction(ApplicationSpecActions.removeOutput(event.value));
    }
  }

  // this function is not used
  setSingleOutput(idx: number, volt: number, current: number) {
    this.act.sendAction(
      ApplicationSpecActions.setSingleOutput(idx, {
        voltage: volt,
        current: current
      })
    );
  }

  resetFilter() {
    this.resetAll.sendReset();
    // this.act.sendAction(ApplicationSpecActions.resetSpec());
  }

}
